import router from '@/router'
import store from '@/store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式
// import { Message } from 'element-ui'
import { GET_TOEKN } from '@/config'
import { routerMap } from '@/router/index'

let flag = true

router.beforeEach((to, from, next) => {
  console.log('TCL: to', to)
  const toPath = flag ? window.location.href : to.path
  NProgress.start()
  if (GET_TOEKN()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      next()
      // if (store.getters.authFinish) {
        // store.dispatch('generateRoutes').then(() => {
        //   router.options.routes = store.getters.allRouters
        //   router.addRoutes(store.getters.allRouters)
        //   store.dispatch('setCurrentPageAuth', to)
        //   if (isNoAuthRouter(toPath)) {
        //     flag = false
        //     next({ path: '/dashboard' })
        //   } else {
        //     next({ ...to, replace: true })
        //   }
        // })
        // store.dispatch('getUserInfo')
        // store.dispatch('getImgURL')
      // } else {
      //   if (isNoAuthRouter(toPath)) {
      //     flag = false
      //     next({ path: '/dashboard' })
      //   } else {
      //     next()
      //   }
      // }
    }
  } else { // 没有token表示没有登錄，自动跳转到登錄頁面
    if (to.path === '/login') {
      next()
    } else {
      next('/login')
    }
    NProgress.done()
  }
})

function isNoAuthRouter (path) {
  for (const value of routerMap.values()) {
    for (const routerData of value) {
      if (path.indexOf(routerData.name) > -1 && !routerData.meta.authFinish) {
        if (path.length - path.indexOf(routerData.name) == routerData.name.length) {
          return true
        }
      }
    }
  }
  return false
}

router.afterEach((to, from, next) => {
  flag = true
  store.dispatch('setCurrentPageAuth', to)
  NProgress.done()// 結束Progress
})
